'use es6';

import { Alignments } from 'rich-text-lib/constants/alignments';
import { ImageAlignmentClasses } from 'rich-text-lib/constants/image';
import { hsimageConfig } from '../constants/image';
import { addPostProcessTransform, addPreProcessTransform } from '../utils/transformer';
import { resizeAssetDimensions } from '../utils/shared';
import { getImageLoadingDefaultValue, getImagePluginSetting } from '../utils/image';
const imagePreprocessTransforms = (editor, dom) => {
  const images = dom.body.querySelectorAll('img');
  const useAlignmentClasses = !!getImagePluginSetting(editor, hsimageConfig.USE_ALIGNMENT_CLASSES);
  const maxContainerWidth = getImagePluginSetting(editor, hsimageConfig.MAX_DIMENSION_WIDTH);
  const autoMaxWidth = !!getImagePluginSetting(editor, hsimageConfig.AUTO_MAX_WIDTH);
  const imageLoadingDefaultValue = getImageLoadingDefaultValue(editor);
  Array.from(images).forEach(image => {
    if (useAlignmentClasses) {
      // Add hs-image-align-none if no class is present
      if (image.className.indexOf('hs-image-align-') < 0) {
        image.classList.add(ImageAlignmentClasses[Alignments.NONE]);
      }
    }
    if (maxContainerWidth) {
      const {
        width,
        height
      } = resizeAssetDimensions(maxContainerWidth, image.width, image.height);
      if (width) {
        image.setAttribute('width', `${width}`);
        image.style.width = `${width}`;
        if (autoMaxWidth) {
          image.style['max-width'] = `${width}`;
        }
      }
      if (height) {
        image.setAttribute('height', `${height}`);
        image.style.height = 'auto';
      }
      if (!image.style.height) {
        // There is not a guarantee that a pasted image will contain
        // a `height` attribute, so the above style does not always
        // get set. This additional check, will make sure we set the
        // inline height style preventing aspect ratio issues in the
        // tinymce instance
        image.style.height = 'auto';
      }
    }
    if (imageLoadingDefaultValue && image.getAttribute('data-mce-paste')) {
      image.loading = imageLoadingDefaultValue;
    }
  });
};
const imagePostProcessTransforms = (editor, dom) => {
  const images = dom.body.querySelectorAll('img[data-mce-paste]:not([src*="blob:"])');
  // We have to query from the actual `editor.dom` in order to get valid
  // width and height rendered values
  const DOMImages = editor.dom.select('img[data-mce-paste]:not([src*="blob:"])');
  Array.from(images).forEach((image, idx) => {
    // Remove [data-mce-paste] attribute from non-blob images
    image.removeAttribute('data-mce-paste');
    // Explicitly set width & height for images missing those attributes
    const domImage = DOMImages[idx];
    if (!image.hasAttribute('width') && domImage.naturalWidth) {
      image.setAttribute('width', domImage.naturalWidth);
    }
    if (!image.hasAttribute('height') && domImage.naturalHeight) {
      image.setAttribute('height', domImage.naturalHeight);
    }
  });
};
export const addTransforms = editor => {
  addPreProcessTransform(editor, dom => {
    imagePreprocessTransforms(editor, dom);
  });
  addPostProcessTransform(editor, dom => {
    imagePostProcessTransforms(editor, dom);
  });
};